import React from "react";
import DayColumn from "./DayColumn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKitchenSet } from "@fortawesome/free-solid-svg-icons";

const WeeklyPlanDisplay = React.memo(({ 
  weeklyPlan, 
  dayTotals, 
  onViewRecipe, 
  onEditRecipe, 
  onDeleteRecipe, 
  currentPlanType,
  onCopyDay,
  onClearDay,
  onClearMeal,
  onClearAllDays,
  onShowPrepList,
  hasPrepItems
}) => {
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "None"];

  console.log("WeeklyPlanDisplay debug:", {
    weeklyPlanLength: weeklyPlan.length,
    currentPlanType,
    hasPrepItems,
    showButton: weeklyPlan.length > 0 && currentPlanType === 'current' && hasPrepItems
  });

  return (
    <div className="container">
      <div className="weekly-plan-header">
        <div className="info-message">
          <small className="text-muted">
            <i className="fas fa-info-circle"></i> Total calories are listed per serving. 
            Modifying entries may re-add ingredients to your shopping list if they were previously crossed off.
          </small>
        </div>
        {weeklyPlan.length > 0 && (
          <div className="header-buttons">
            {currentPlanType === 'current' && (
              <button
                className="btn btn-outline-warning btn-sm prep-list-btn me-2"
                onClick={onShowPrepList}
              >
                <FontAwesomeIcon icon={faKitchenSet} className="me-1" />
                Weekly Prep List {!hasPrepItems && "(0)"}
              </button>
            )}
            <button
              className="btn btn-outline-danger btn-sm clear-all-days-btn"
              onClick={onClearAllDays}
            >
              <i className="fas fa-trash-alt me-1"></i>
              Clear All Days
            </button>
          </div>
        )}
      </div>
      <div className="row">
        {days.map((day) => (
          <DayColumn
            key={day}
            day={day}
            recipes={weeklyPlan}
            dayTotals={dayTotals}
            onViewRecipe={onViewRecipe}
            onEditRecipe={onEditRecipe}
            onDeleteRecipe={onDeleteRecipe}
            currentPlanType={currentPlanType}
            onCopyDay={onCopyDay}
            onClearDay={onClearDay}
            onClearMeal={onClearMeal}
          />
        ))}
      </div>
    </div>
  );
});

export default WeeklyPlanDisplay;